export const sanitize = (value = '') => value != null ? value.trim() : ''

// Replace variables wrapped in {{ }} by values provided
export const insertValuesInTranslation = (translation, values) => {
  if (!translation || !values) return false;
  return Object.keys(values)
    .reduce((message, key) => {
      const regexp = new RegExp('\{\{' + key + '\}\}', 'g');
      return message.replace(regexp, values[key]);
    }, translation);
}

export const translate = (key, values) => {
  const message = window.NFT.I18n[key]
  if (!values) return message || ''

  return insertValuesInTranslation(message, values)
}
